import { createRepository } from '@/shared/repositories/Repository'
import { BASE_URL } from '@/shared/api'
import { logout } from '@/shared/lib/auth/authorize'

const logoutRepository = createRepository({
  basePath: BASE_URL,
  useAuth: true
})

export const PostLogout = async () => {
  try {
    const result = await logoutRepository.post('/logout')
    // После успешного logout на сервере очищаем локальные данные
    logout()
    return result
  } catch (error) {
    // Даже если сервер вернул ошибку, очищаем локальные данные
    logout()
    throw error
  }
} 